module.exports = __webpack_public_path__ + "img/selected2-min.081c7206.png";